import React, { useState } from 'react';
import Select from 'react-select';

const CouponModal = ({ isOpen, setIsOpen }) => {
    const [coupon, setCoupon] = useState('');
    const [discountPercent, setDiscountPercent] = useState('');
    const [priceDiscount, setPriceDiscount] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [couponUsage, setCouponUsage] = useState('');
    const [status, setStatus] = useState(null);
    
    if (!isOpen) return null;

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle the form submission logic here
        console.log({
            coupon,
            discountPercent,
            priceDiscount,
            startDate,
            endDate,
            couponUsage,
            status,
        });
        setIsOpen(false); // Close modal after submission
    };

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Coupon Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="coupon" className="oms-form-label">
                            Coupon
                        </label>
                        <input
                            type="text"
                            id="coupon"
                            value={coupon}
                            onChange={(e) => setCoupon(e.target.value)}
                            placeholder="Enter coupon code"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="discountPercent" className="oms-form-label">
                            Discount (%)
                        </label>
                        <input
                            type="number"
                            id="discountPercent"
                            value={discountPercent}
                            onChange={(e) => setDiscountPercent(e.target.value)}
                            placeholder="Enter discount percentage"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="priceDiscount" className="oms-form-label">
                            Price Discount
                        </label>
                        <input
                            type="number"
                            id="priceDiscount"
                            value={priceDiscount}
                            onChange={(e) => setPriceDiscount(e.target.value)}
                            placeholder="Enter price discount"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="startDate" className="oms-form-label">
                            Start Date
                        </label>
                        <input
                            type="date"
                            id="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="endDate" className="oms-form-label">
                            End Date
                        </label>
                        <input
                            type="date"
                            id="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="couponUsage" className="oms-form-label">
                            Coupon Usage
                        </label>
                        <input
                            type="number"
                            id="couponUsage"
                            value={couponUsage}
                            onChange={(e) => setCouponUsage(e.target.value)}
                            placeholder="Enter coupon usage limit"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select
                            id="status"
                            options={statusOptions}
                            value={status}
                            onChange={setStatus}
                            placeholder="Select status"
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CouponModal;
